export default function EFFan(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1748 2C18.9845 2 21.5283 3.13889 23.3696 4.98022C25.2109 6.82155 26.3498 9.36533 26.3498 12.1751C26.3498 14.9849 25.2109 17.5287 23.3696 19.37C21.5283 21.2113 18.9845 22.3502 16.1748 22.3502C13.365 22.3502 10.8213 21.2113 8.97995 19.37C7.13863 17.5287 5.99976 14.9849 5.99976 12.1751C5.99976 9.36533 7.13863 6.82155 8.97995 4.98022C10.8213 3.13889 13.365 2 16.1748 2Z"
                stroke="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1738 9.61133C16.8817 9.61133 17.5227 9.89829 17.9866 10.3622C18.4506 10.8262 18.7376 11.4672 18.7376 12.1751C18.7376 12.8831 18.4506 13.5241 17.9866 13.988C17.5227 14.452 16.8817 14.7389 16.1738 14.7389C15.4658 14.7389 14.8249 14.452 14.3609 13.988C13.8969 13.5241 13.61 12.8831 13.61 12.1751C13.61 11.4672 13.8969 10.8262 14.3609 10.3622C14.8249 9.89829 15.4658 9.61133 16.1738 9.61133Z"
                stroke="currentColor"
            />
            <path
                d="M17.0659 9.23285C17.8197 6.3342 18.6162 4.69526 19.3336 4.89735C20.4098 5.20049 22.0344 6.23418 21.8621 7.58162C21.7163 8.72214 20.3621 10.3426 18.7121 11.7165"
                stroke="currentColor"
            />
            <path
                d="M18.4459 13.7266C20.9697 15.3392 22.2823 16.6032 21.8684 17.2231C21.2475 18.153 19.7624 19.3786 18.5342 18.7984C17.4946 18.3072 16.3719 16.5186 15.5751 14.5248"
                stroke="currentColor"
            />
            <path
                d="M13.3099 13.1515C10.5414 14.294 8.7531 14.6442 8.48272 13.9496C8.07716 12.9077 7.92499 10.9881 9.10479 10.3148C10.1034 9.74491 12.2125 9.85118 14.3027 10.3421"
                stroke="currentColor"
            />
            <path d="M15.279 22.603L14.6154 27.941" stroke="currentColor" />
            <path d="M18.4729 22.5793L19.3063 27.8935" stroke="currentColor" />
            <path
                d="M23.1182 28.0771H10.2993C9.76833 28.0771 9.33789 28.5076 9.33789 29.0386C9.33789 29.5696 9.76833 30 10.2993 30H23.1182C23.6492 30 24.0797 29.5696 24.0797 29.0386C24.0797 28.5076 23.6492 28.0771 23.1182 28.0771Z"
                stroke="currentColor"
            />
            <path d="M21.5356 25.9683V27.7771" stroke="currentColor" strokeLinecap="round" />
        </svg>
    );
}
